import type {
  AuthCredentials,
  AuthDataResponse,
  CreatePasswordPayload,
  CreatePasswordResponse,
} from '@/domains/auth/auth.entity';
import type { AuthRepository } from '@/domains/auth/auth.repository';
import { AuthResponseValueObject } from '@/domains/auth/authResponse.valueObject';
import { authApiService } from '../http/auth.api';

/**
 * Implementación del repositorio de autenticación que coordina operaciones de login y creación de contraseñas
 * Cumple con ISP - Interface Segregation Principle
 */
class AuthApiRepository implements AuthRepository {
  /**
   * Autentica usuario con credenciales y valida la respuesta del servidor
   * @param credentials - Objeto con correo y contraseña del usuario
   */
  async login(credentials: AuthCredentials): Promise<AuthDataResponse> {
    const authResponse = await authApiService.login(credentials);

    const validatedResponse = AuthResponseValueObject.create(authResponse.data);

    return validatedResponse.getValue();
  }

  /**
   * Crea o actualiza la contraseña de un usuario
   * @param payload - Datos necesarios para establecer nueva contraseña
   */
  async createPassword(
    payload: CreatePasswordPayload,
  ): Promise<CreatePasswordResponse> {
    const createPassword = await authApiService.createPassword(payload);

    if (!createPassword) throw new Error('Error al crear la nueva constraseña');

    return createPassword;
  }
}

export const authApiRepository = new AuthApiRepository();
